import styled from 'styled-components'

export const Item = styled.div<{ $isDragging: boolean; $disabled?: boolean }>`
  position: absolute;
  height: 100%;
  border-radius: 4px;
  cursor: grab;
  user-select: none;
  box-sizing: border-box;
  opacity: ${({ $disabled }) => ($disabled ? 0.7 : 1)};
  z-index: ${({ $isDragging }) => ($isDragging ? 2 : 1)};
`
